var map = {
	"./favicon.png": 43,
	"./gradient.png": 13,
	"./projects/previews/afrs_preview.png": 44,
	"./projects/previews/capstone_preview_2.png": 45,
	"./projects/previews/healthnet_preview.png": 46,
	"./projects/previews/main_background_small.jpg": 47,
	"./projects/previews/pantreats_preview.png": 48,
	"./projects/previews/raytrace.png": 49,
	"./projects/previews/thesis_placeholder.jpg": 50,
	"./projects/previews/vue-website-icon.png": 51,
	"./projects/previews/vue-website-icon2.png": 52,
	"./projects/previews/website_preview_3.png": 53,
	"./test.png": 54,
	"./website-data": 3,
	"./website-data.json": 3
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 1
// module chunks = 0